var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminOrdersSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isExternal: true,
      forceTab: "inboundDeliveries"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "content-centered large"
  }, [!_vm.isFetching && !_vm.isDraft && _vm.isValid && _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminInboundDeliveryDetails", {
    attrs: {
      baseModel: _vm.inboundDelivery,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm._e(), !_vm.isValid && !_vm.isFetching ? _c("Error", {
    attrs: {
      error: _vm.error
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };